import { render, staticRenderFns } from "./inmueble-burbuja-consolidados.vue?vue&type=template&id=7d8052f6&"
import script from "./inmueble-burbuja-consolidados.vue?vue&type=script&lang=js&"
export * from "./inmueble-burbuja-consolidados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports